import { useSelector } from 'react-redux';
import { defaultResultPageSettings } from 'config/promoDefaultSettingValue';
import { isResultPageTypeA } from 'config/promoGameTypes';

export default function useResultPage() {
    const gameType = useSelector(s => s.promo.type);
    const settingResultPage = useSelector(s => s.settingStyle?.resultPage) || {};
    const defaultResultPage = {
        ...defaultResultPageSettings().resultPage,
        //A模組預設主辦方的話開啟
        sponsorSlotEnabled: isResultPageTypeA(gameType)
    };
    return { ...defaultResultPage, ...settingResultPage };
}
